import type { MediaAsset } from '@/lib/media/mediaTypes';

export interface ProducerFormData {
  name: string;
  slug: string;
  shortDescription: string;
  longDescription: string;
  address: string;
  city: string;
  region: string;
  lat: string;
  lng: string;
  categories: string[];
  phone: string;
  website: string;
  instagram: string;
  facebook: string;
  email: string;
  openingHoursText: string;
  farmShopIntro: string;
  farmShopOpeningHoursText: string;
  phonePublic: boolean;
  emailPublic: boolean;
  websitePublic: boolean;
  instagramPublic: boolean;
  facebookPublic: boolean;
  hasFarmShop: boolean;
  hasFarmSaleAlcohol: boolean;
  farmShopStatus: 'open' | 'closed' | 'seasonal';
  capabilitySuggestion: string;
  /** @deprecated – kept for backward compat during migration */
  coverUrl: string;
  /** @deprecated – kept for backward compat during migration */
  galleryUrls: string[];
  /** New: media_assets-backed cover */
  coverAssets: MediaAsset[];
  /** New: media_assets-backed gallery */
  galleryAssets: MediaAsset[];
  /** Mat & fika: sanitized HTML from RichTextEditor */
  foodDescription: string;
  /** Mat & fika: selected serving-type keys */
  foodServingTypes: string[];
  status: 'draft' | 'public';
  verified: boolean;
}

export const EMPTY_FORM_DATA: ProducerFormData = {
  name: '',
  slug: '',
  shortDescription: '',
  longDescription: '',
  address: '',
  city: '',
  region: '',
  lat: '',
  lng: '',
  categories: [],
  phone: '',
  website: '',
  instagram: '',
  facebook: '',
  email: '',
  openingHoursText: '',
  farmShopIntro: '',
  farmShopOpeningHoursText: '',
  phonePublic: false,
  emailPublic: false,
  websitePublic: false,
  instagramPublic: false,
  facebookPublic: false,
  hasFarmShop: false,
  hasFarmSaleAlcohol: false,
  farmShopStatus: 'closed',
  capabilitySuggestion: '',
  coverUrl: '',
  galleryUrls: [''],
  coverAssets: [],
  galleryAssets: [],
  foodDescription: '',
  foodServingTypes: [],
  status: 'draft',
  verified: false,
};

export const AVAILABLE_CATEGORIES = [
  'Grönsaker',
  'Kött',
  'Mejeri',
  'Ägg',
  'Honung',
  'Frukt & bär',
  'Bageri',
  'Drycker',
  'Ekologiskt',
  'KRAV-märkt',
  'Gårdsbutik',
  'Café',
  'Boende',
  'Upplevelser',
];

export const REGIONS = [
  'Blekinge',
  'Bohuslän',
  'Dalarna',
  'Dalsland',
  'Gotland',
  'Gästrikland',
  'Halland',
  'Hälsingland',
  'Härjedalen',
  'Jämtland',
  'Lappland',
  'Medelpad',
  'Norrbotten',
  'Närke',
  'Skåne',
  'Småland',
  'Södermanland',
  'Uppland',
  'Värmland',
  'Västerbotten',
  'Västergötland',
  'Västmanland',
  'Ångermanland',
  'Öland',
  'Östergötland',
];

export interface NavItem {
  value: string;
  label: string;
  icon: React.ElementType;
  show: boolean;
}
